module.exports = __webpack_public_path__ + "img/procedural_growth_sphere.f1f6d13a.gif";